import { twMerge } from '@panwds/tailwindcss';
import React from 'react';
export function BottomNav({ children, addClassName, dataMetrics, dataTestId }) {
    return (React.createElement("ul", { "data-metrics": dataMetrics, "data-testid": dataTestId || 'bottom-nav', className: twMerge('twds-box-border twds-list-none twds-m-0 twds-p-0 twds-border-b-0 twds-border-l-0 twds-border-r-0 twds-border-solid twds-border-t twds-border-blue-steel-700 dark:twds-border-gray-950', addClassName) }, children));
}
//# sourceMappingURL=BottomNav.js.map